<template>
  <div id="mixcloudWrapper"
       class="fixed-bottom-mix"
       :data-provider="audioProvider" >
    <div id="mixcloudModule"
         class="d-flex flex-row align-items-center slide-in-bottom mixcloud-bg mixcloud-border justify-content-between audioPlayerModule">
      <div id="mixcloudContainer"
           ref="mixcloudContainer"
           class="w-mix-cloud"
      />
      <div class="pl-3 pr-3 ">
        <div class="ping">
          <div class="circle" />
        </div>
      </div>
      <div class="player-component-info">
        <div class="player-component-info__item">
          <span>EPISODE</span>
          <router-link class="mvmnt-link" :to="{ path: '/show/' + episodePermlink }">
            {{ episodeTitle }}
          </router-link>
        </div>
        <div v-if="getArtist" class="player-component-info__item">
          <span>ARTIST PROFILE</span>
          <router-link class="mvmnt-link" :to="{ path: '/artist/' + getArtist.permlink }">
            {{ getArtist.name }}
          </router-link>
        </div>
      </div>
      <div class="player-close-button flex-shrink-0 bd-highlight">
        <button
          type="button"
          aria-label="Close"
          class="close close-mix"
          @click="destroyMixcloud()"
        >
          <IconClose />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import IconClose from "@/components/svg/IconClose.vue";
import {mapState} from "vuex";
import './widgetApi';

export default {
  name: "PlayerMixcloud",
  components: {IconClose},
  data() {
    return {
      currentMixcloudId: null,
      showDataFetched: null,
      showRouterFetched: null,
      podcastRouterFetched: null,
      podcastDataFetched: null,
      widget: null
    }
  },
  computed: {
    ...mapState({
      isProviderPlaying() {
        return this.$store.getters['audioPlayer/getAudioPlayerIsPlaying'];
      },
      episodeTitle() {
        return this.$store.getters['audioPlayer/getEpisodeTitle'];
      },
      episodeUrl() {
        return this.$store.getters['audioPlayer/getEpisodeUrl'];
      },
      episodePermlink() {
        return this.$store.getters['audioPlayer/getEpisodePermlink'];
      },
      podcastTitle() {
        return this.$store.getters['audioPlayer/getPodcastTitle'];
      },
      podcastPermlink() {
        return this.$store.getters['audioPlayer/getPodcastPermlink'];
      },
      audioProvider() {
        return this.$store.getters['audioPlayer/getProvider'];
      },
      trigger() {
        return this.$store.getters['audioPlayer/getTrigger'];
      },
      getArtist() {
        return this.$store.getters['audioPlayer/getArtist'];
      }
    })
  },

  watch: {
    episodeUrl() {
      this.destroyMixcloudIframe();
      this.$store.dispatch('audioPlayer/destroy');
      this.renderMixcloudPlayer();
    },
    trigger() {
      this.renderMixcloudPlayer();
    },
  },
  mounted() {
    this.renderMixcloudPlayer();
  },
  methods: {
    constructMixcloudIdFromUrl() {
      const episodeUrl = this.$store.getters['audioPlayer/getEpisodeUrl'];
      const encoded = encodeURIComponent(episodeUrl);
      return btoa(encoded).replace(/=/gi, '');
    },
    createMixcloudIframeElement(id, url) {
      return new Promise((resolve) => {
        const iframe = document.createElement('iframe');
        iframe.setAttribute('id', id);
        iframe.setAttribute(
            'src',
            `https://www.mixcloud.com/widget/iframe/?hide_cover=1&mini=1&light=1&feed=${url}&autoplay=1`
        );
        iframe.setAttribute('class', 'w-100 h-60');
        iframe.setAttribute('frameBorder', '0');
        iframe.setAttribute('allow', 'autoplay');
        this.$refs.mixcloudContainer.appendChild(iframe);
        iframe.onload = () => {
          resolve(iframe);
        }
      });
    },
    async renderMixcloudPlayer() {
      const episodeUrl = this.$store.getters['audioPlayer/getEpisodeUrl'];
      const id = this.constructMixcloudIdFromUrl();
      const iframeMixcloud = this.$refs.mixcloudContainer.querySelectorAll('iframe[id=' + id + ']');
      if (this.currentMixcloudId === id) {
        this.isProviderPlaying ? this.widget.pause() : this.widget.play();
      }
      if (iframeMixcloud.length === 0) {
        this.destroyMixcloudIframe();
        await this.createMixcloudIframeElement(id, episodeUrl);
        this.currentMixcloudId = id;
        const mixcloudIframe = document.getElementById(this.currentMixcloudId);
        this.widget = Mixcloud.PlayerWidget(mixcloudIframe);
        this.widget.ready.then(() => {
          this.widget.getIsPaused().then(e => {
            this.$store.dispatch('audioPlayer/suspend');
          })
          this.widget.events.pause.on(() => {
            // console.log('widget ON PAUSE:::');
            this.$store.commit('audioPlayer/setIsPlaying', false);
          });
          this.widget.events.play.on(() => {
            // console.log('widget ON PLAY:::');
            this.$store.commit('audioPlayer/setIsPlaying', true);
          });
          this.widget.events.buffering.on(() => {
            // console.log('widget ON buffering:::');
            this.$store.commit('audioPlayer/setIsPlaying', false);
          });
        });

      }
    },
    destroyMixcloud() {
      this.$store.commit('audioPlayer/setProvider', null);
      this.$store.dispatch('audioPlayer/resetSuspend');
    },
    destroyMixcloudIframe() {
      this.$store.dispatch('audioPlayer/resetSuspend');
      while (this.$refs.mixcloudContainer.firstChild) {
        this.$refs.mixcloudContainer.removeChild(this.$refs.mixcloudContainer.firstChild);
      }
    },
  }
}
</script>


<style scoped lang="scss">
@import "@/assets/sass/components/players/player-audio";
</style>